import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
const Bold = styled.span `
  font-weight: bold;
`;
/**
 * VoiceOver (Apple's official screen reader) on iOS reads "mytonies" with our
 * brand-specific highlighting as two separate elements when used inside of a
 * link (<a>): "my hyperlink" and "tonies hyperlink". Using the non-official
 * role 'text' as a wrapper around this prevents this so that "mytonies
 * hyperlink" is read.
 */
export const Brand = () => {
    return (
    // eslint-disable-next-line jsx-a11y/aria-role
    React.createElement("span", { role: "text" },
        React.createElement(Trans, { i18nKey: "Brand:BrandName", components: {
                Bold: React.createElement(Bold, null),
            } })));
};
